// extracted by mini-css-extract-plugin
export default {"main":"video_main__mpbHK","video":"video_video__y4nL3","textM":"video_textM__WaBOJ","text1M":"video_text1M__Q0wuY","text2M":"video_text2M__ToqPr"};